import React, { FunctionComponent } from "react";
import { IIconProps } from "../icon";

export const EmojiAngry: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  return (
    <svg viewBox="0 0 52 52" {...rest}>
      <g
        id="Icons/Body/Emoji-Angry"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Group-2" transform="translate(3.000000, 3.000000)" stroke="#222222" strokeWidth="3">
          <path
            d="M14.7220444,7.66666667 C16.9934605,9.70027321 19.9518978,10.7962613 23,10.7333333 C26.0481022,10.7962613 29.0065395,9.70027321 31.2779556,7.66666667"
            id="Path"
          ></path>
          <path
            d="M0,23 C0,35.7025492 10.2974508,46 23,46 C35.7025492,46 46,35.7025492 46,23 C46,10.2974508 35.7025492,0 23,0 C10.2974508,0 0,10.2974508 0,23 Z"
            id="Path"
          ></path>
          <path
            d="M15.3333333,16.1 C15.7567516,16.1 16.1,16.4432484 16.1,16.8666667 C16.1,17.290085 15.7567516,17.6333333 15.3333333,17.6333333 C14.909915,17.6333333 14.5666667,17.290085 14.5666667,16.8666667 C14.5666667,16.4432484 14.909915,16.1 15.3333333,16.1"
            id="Path"
          ></path>
          <path
            d="M30.6666667,16.1 C31.090085,16.1 31.4333333,16.4432484 31.4333333,16.8666667 C31.4333333,17.290085 31.090085,17.6333333 30.6666667,17.6333333 C30.2432484,17.6333333 29.9,17.290085 29.9,16.8666667 C29.9,16.4432484 30.2432484,16.1 30.6666667,16.1"
            id="Path"
          ></path>
          <path
            d="M16.8666667,33.7333333 C16.8666667,37.1206798 19.6126535,39.8666667 23,39.8666667 C26.3873465,39.8666667 29.1333333,37.1206798 29.1333333,33.7333333 C29.1333333,30.3459869 26.3873465,27.6 23,27.6 C19.6126535,27.6 16.8666667,30.3459869 16.8666667,33.7333333 Z"
            id="Path"
          ></path>
        </g>
      </g>
    </svg>
  );
};
